import {
  type PulseIndexPagePulseFragment,
  type PulsesQuery,
  usePulsesQuery,
  withStandardListHook,
} from '@spotify/confidence-graphql';

const DEFAULT_PAGE_SIZE = 25;

const usePulsesImpl = withStandardListHook<
  PulsesQuery,
  PulseIndexPagePulseFragment,
  'pulses'
>(usePulsesQuery, 'pulses');

type UsePulsesOptions = Parameters<typeof usePulsesImpl>[0];
type UsePulsesResult = ReturnType<typeof usePulsesImpl>;

export const usePulses = (options?: UsePulsesOptions): UsePulsesResult =>
  usePulsesImpl({
    pageSize: DEFAULT_PAGE_SIZE,
    ...options,
  });
